import React from "react";

import { SettingsService } from "@pro/_services";
import { DashboardTile } from "@pro/components/Organisms/DashboardTile";
import { SendMessage } from "@pro/containers/Modals/SendMessage";

import { Button } from "@common/components/Atoms/Button";
import RelodeRep from "@common/components/Atoms/RelodeRep";
import { Manager as ManagerModel, TileSize } from "@common/models";

interface DashboardTileRecruiterFooterProps {
    managerId: number;
}

interface DashboardTileRecruiterFooterState {
    isOpen: boolean;
}

export class DashboardTileRecruiterFooter extends React.Component<
    DashboardTileRecruiterFooterProps,
    DashboardTileRecruiterFooterState
> {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({ isOpen: true });
    }

    closeModal() {
        this.setState({ isOpen: false });
    }

    render() {
        return (
            <div className="c-dashboard__tile-footer">
                <Button
                    id="button-message-coach"
                    green={true}
                    small={true}
                    onClick={this.openModal}
                >
                    message coach
                </Button>
                {this.state.isOpen && (
                    <SendMessage
                        isOpen={this.state.isOpen}
                        closeModal={this.closeModal}
                        onCancel={this.closeModal}
                        toUserIds={[this.props.managerId]}
                    />
                )}
            </div>
        );
    }
}

interface QuestionsState {
    managerId: number;
    advisor: {
        status: string;
        response: {
            user_id: number;
            profile_image_url: string;
            last_name: string;
            first_name: string;
            role_name: string;
            phone_number_for_url: string;
            phone_number: string;
        };
    };
}
export class Questions extends React.Component<any, QuestionsState> {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props) {
        super(props);

        this.state = {
            managerId: 0,
            advisor: {
                status: "pending",
                response: {
                    user_id: 0,
                    profile_image_url: "",
                    last_name: "",
                    first_name: "",
                    role_name: "",
                    phone_number_for_url: "",
                    phone_number: "",
                },
            },
        };
    }

    componentDidMount() {
        if (this.state.advisor.status !== "success") {
            // Check to see if there already was an abortController, and if so, call abort on it
            if (this._abortControllers.getManager) {
                this._abortControllers.getManager.abort();
            }
            this._abortControllers.getManager = new AbortController();
            const signal = this._abortControllers.getManager.signal;

            SettingsService.getManager(signal).then(resp => {
                this.setState({
                    managerId: resp.user_id,
                    advisor: { status: "success", response: resp },
                });
            });
        }
    }

    componentWillUnmount() {
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key =>
                abortControllers[key].abort()
            );
        }
    }

    render() {
        const { advisor } = this.state;
        return (
            <DashboardTile
                title="questions?"
                description="always here to help"
                size={TileSize.sm}
                loading={advisor.status === "pending"}
                showFade={false}
                footer={
                    <DashboardTileRecruiterFooter
                        managerId={
                            advisor.status === "success" &&
                            advisor.response.user_id
                                ? advisor.response.user_id
                                : -1
                        }
                    />
                }
            >
                <div className="c-dashboard__advisor">
                    {advisor.status === "success" && (
                        <div>
                            <RelodeRep
                                image={advisor.response.profile_image_url}
                                name={
                                    advisor.response.first_name +
                                    " " +
                                    advisor.response.last_name
                                }
                            >
                                <span className="u-text-gray">
                                    {advisor.response.role_name}
                                </span>
                            </RelodeRep>
                            <p>
                                <span>
                                    responds within 24 hours
                                    <br />
                                    <a
                                        href={`tel:${advisor.response.phone_number_for_url}`}
                                    >
                                        {advisor.response.phone_number}
                                    </a>
                                    {/* (text anytime) DON'T HAVE SMS QUITE YET */}
                                </span>
                            </p>
                            <p>
                                <strong>availability</strong>
                                <br />
                                Mon - Fri: 8-5PM CST
                                <br />
                                closed holidays
                            </p>
                        </div>
                    )}
                </div>
            </DashboardTile>
        );
    }
}
